import React from "react";
import { Toggle } from "@fluentui/react";
import { IdentityAddressInputsProps } from "@/screen/Identities/IdentityAddressInputs/Interfaces/IdentityAddressInputsInterfaces";
import { AddressSectionSubheading, FormSection, FormRow, FormField, ToggleRow, ToggleRowLabel } from "@/screen/Identities/IdentityAddressInputs/Styles/IdentityAddressInputsStyles";
import AddressSectionInputs from "@/screen/Identities/IdentityAddressInputs/AddressSectionInputs";

const IdentityAddressInputs: React.FC<IdentityAddressInputsProps> = ({formData, validation, highlightPendingManualFields, isFormLocked, onPostalAddressChange, onFiscalAddressChange, onSameAddressToggle, onCascadeLoadingChange}) =>
{
    const [postalCascadeLoading, setPostalCascadeLoading] = React.useState<boolean>(false);
    const [fiscalCascadeLoading, setFiscalCascadeLoading] = React.useState<boolean>(false);

    React.useEffect(() =>
    {
        onCascadeLoadingChange(postalCascadeLoading || (!formData.sameAddress && fiscalCascadeLoading));
    }, [postalCascadeLoading, fiscalCascadeLoading, formData.sameAddress, onCascadeLoadingChange]);

    return(
        <FormSection>
            <h3>Dirección Postal</h3>
            <AddressSectionInputs prefix="postal" address={formData.postalAddress}
                isFormLocked={isFormLocked} onChange={onPostalAddressChange}
                highlightPendingManualFields={highlightPendingManualFields}
                sectionAddressComplete={validation.postalAddress}
                onLoadingChange={setPostalCascadeLoading}
            />
            <FormRow>
                <FormField style={{flex: "1"}}>
                    <ToggleRow>
                        <ToggleRowLabel>Tengo la misma dirección fiscal</ToggleRowLabel>
                        <Toggle ariaLabel="Tengo la misma dirección fiscal" checked={formData.sameAddress} onChange={onSameAddressToggle}
                            disabled={isFormLocked}
                        />
                    </ToggleRow>
                </FormField>
            </FormRow>
            {!formData.sameAddress &&
            (
                <React.Fragment>
                    <AddressSectionSubheading>Dirección Fiscal</AddressSectionSubheading>
                    <AddressSectionInputs prefix="fiscal" address={formData.fiscalAddress}
                        isFormLocked={isFormLocked} onChange={onFiscalAddressChange}
                        highlightPendingManualFields={highlightPendingManualFields}
                        sectionAddressComplete={validation.fiscalAddress}
                        onLoadingChange={setFiscalCascadeLoading}
                    />
                </React.Fragment>
            )}
        </FormSection>
    );
};

export default IdentityAddressInputs;